module.exports = __webpack_public_path__ + "static/endpoint-orange-c35c51f6dba2ef695091a7be8e21003f.png";